import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { StepIndicator } from './StepIndicator';

interface StepDef {
  key: string;
  label: string;
}

interface WizardShellProps {
  steps: StepDef[];
  currentIndex: number;
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Oculta o indicador de passos (ex.: na tela de sucesso). */
  hideStepper?: boolean;
}

/**
 * Casca visual do wizard: card centralizado sobre o gradiente das telas
 * públicas, com logo, indicador de passos, título e slot de conteúdo.
 */
export function WizardShell({
  steps,
  currentIndex,
  title,
  subtitle,
  children,
  hideStepper = false,
}: WizardShellProps) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-900 to-navy-700 py-[30px] px-4">
      <div className="mx-auto w-full max-w-[520px]">
        {/* Logo */}
        <div className="text-center mb-[20px]">
          <img src="/images/logo_login.png" alt="Laager" className="inline-block max-h-[60px]" />
        </div>

        {/* Card */}
        <div className="bg-white rounded-[12px] shadow-[0_10px_40px_rgba(0,0,0,0.25)] px-[26px] py-[28px]">
          {!hideStepper && <StepIndicator steps={steps} current={currentIndex} />}

          <h1 className="text-[19px] font-bold text-navy-800 mb-[4px]">{title}</h1>
          {subtitle && <p className="text-[13px] text-navy-700/80 mb-[20px] leading-[1.5]">{subtitle}</p>}
          {!subtitle && <div className="mb-[16px]" />}

          {children}
        </div>

        {/* Voltar para o login */}
        <p className="text-center mt-[18px] text-[12px] text-white/80">
          {t('views.registration.have_account', 'Já tem conta?')}{' '}
          <Link
            to="/login"
            className="text-sky-500 hover:text-sky-500/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-500 underline font-semibold transition-colors"
          >
            {t('views.login.sign_in', 'Entrar')}
          </Link>
        </p>
      </div>
    </div>
  );
}
